import * as React from 'react'
import { GridPrivateApiCommunity } from '../../../models/api/gridApiCommunity'
import { GridParamsApi } from '../../../models/api/gridParamsApi'
import {
  getGridCellElement,
  getGridColumnHeaderElement,
  getGridRowElement,
} from '../../../utils/domUtils'
import { useGridApiMethod } from '../../utils/useGridApiMethod'

export function useGridParamsApi(
  apiRef: React.MutableRefObject<GridPrivateApiCommunity>
) {
  const getCellElement = React.useCallback<GridParamsApi['getCellElement']>(
    (id, field) => {
      if (!apiRef.current.rootElementRef!.current) {
        return null
      }
      return getGridCellElement(apiRef.current.rootElementRef!.current!, {
        id,
        field,
      })
    },
    [apiRef]
  )

  const getRowElement = React.useCallback<GridParamsApi['getRowElement']>(
    id => {
      if (!apiRef.current.rootElementRef!.current) {
        return null
      }
      return getGridRowElement(apiRef.current.rootElementRef!.current!, id)
    },
    [apiRef]
  )
  const getColumnHeaderElement = React.useCallback<
    GridParamsApi['getColumnHeaderElement']
  >(
    field => {
      if (!apiRef.current.rootElementRef!.current) {
        return null
      }
      return getGridColumnHeaderElement(
        apiRef.current.rootElementRef!.current!,
        field
      )
    },
    [apiRef]
  )

  const paramsApi: GridParamsApi = {
    getCellElement,
    getRowElement,
    getColumnHeaderElement,
  }

  useGridApiMethod(apiRef, paramsApi, 'public')
}
